var _rect, _rect2, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCohortBasedCourse = function SvgCohortBasedCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#966BD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.941,
    y: 29.155,
    width: 6.112,
    height: 1.667,
    rx: 0.387,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.032 18.439a.557.557 0 0 1 .12-.608l3.284-3.283a.557.557 0 1 1 .788.788l-2.332 2.332h3.365a.557.557 0 0 1 .394.951l-3.284 3.284a.557.557 0 1 1-.788-.788l2.332-2.332h-3.364a.557.557 0 0 1-.515-.344Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.61 26.752a9.17 9.17 0 0 0-3.612-17.596 9.167 9.167 0 0 0-3.611 17.596v1.77c0 .044.034.078.077.078h7.068a.078.078 0 0 0 .077-.077v-1.771Zm-6.578-8.311a.558.558 0 0 1 .121-.607l3.284-3.284a.557.557 0 1 1 .788.788l-2.332 2.332h3.364a.557.557 0 0 1 .394.952l-3.284 3.283a.557.557 0 1 1-.788-.788l2.333-2.332h-3.365a.557.557 0 0 1-.515-.344Z",
    fill: "url(#cohort-based-course_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cohort-based-course_svg__a",
    x1: 19.998,
    y1: 9.156,
    x2: 19.999,
    y2: 35.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgCohortBasedCourse;